import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import noop from 'lodash/noop'
import React from 'react'
import { Mutation } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import EditButton from '../../../common/iconButtons/EditButton'
import RestrictedView from '../../auth/RestrictedView'
import withUser from '../../auth/withUser'
import { deleteMarketQuestion, fetchMarketQuestions } from './marketQuestionQueries'
import css from './marketQuestionTable.css'
import type { MarketQuestion } from './marketQuestionTypes'

type MarketQuestionRowProps = {
  data: MarketQuestion
  onEdit: (...props: any) => any
}

const updateCacheOnDelete = (id: string) => (cache: any) => {
  const { marketQuestions } = cache.readQuery({
    query: fetchMarketQuestions,
  })

  cache.writeQuery({
    query: fetchMarketQuestions,
    data: {
      marketQuestions: marketQuestions.filter((mq) => mq.id !== id),
    },
  })
}

@withUser
class MarketQuestionRow extends React.PureComponent<MarketQuestionRowProps> {
  onDelete = (onMutate: (...props: any) => any, id: string) => {
    onMutate({
      variables: { id },
      update: updateCacheOnDelete(id),
    })
  }

  render() {
    const { data, onEdit } = this.props

    return (
      <TableRow>
        <TableCell className={css.tableCell}>{data.description}</TableCell>
        <RestrictedView requiredPermission='manage_ownStation'>
          <TableCell className={css.actionsCell}>
            <EditButton onClick={() => (data.id ? onEdit(data) : noop)} />
            <Mutation mutation={deleteMarketQuestion}>
              {(onMutate) => <DeleteButton onClick={() => (data.id ? this.onDelete(onMutate, data.id) : noop)} />}
            </Mutation>
          </TableCell>
        </RestrictedView>
      </TableRow>
    )
  }
}

export default MarketQuestionRow
